import * as actionTypes from "../types";

const initialState = {
    addedEbook: false,
    ebooks: [],
    ebookEmpty: false,
    deletedEbook: false,
    updatedEbook: false

}

export default function ebookReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.GET_EBOOK: {
            return {
                ...state,
                ebooks: action.payload.ebooks,
                ebookEmpty: action.payload.ebookEmpty
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
}


